import {
  FunctionComponent,
  isValidElement,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { FormLayout } from '@shopify/polaris';
import { get } from 'lodash';
import { RadioStack, Separator } from '@ui';
import Input, { InputContainer, InputProps } from '@ui/input';
import { ExtendedRadioButtonProps } from '@ui/radio-stack';

export interface OptionStackProps {
  initialOption: string;
  onToggle(status: boolean, id: string): void;
  buttons: ExtendedRadioButtonProps[];
  onInputChange?(value: string, id: string): void;
  bottomInputs: Record<string, Partial<InputProps> | React.ReactNode>;
}

const OptionStack: FunctionComponent<OptionStackProps> = ({
  initialOption,
  onToggle,
  buttons,
  onInputChange = () => ({}),
  bottomInputs,
}) => {
  const [option, setOption] = useState(initialOption);

  useEffect(() => {
    setOption(initialOption);
  }, [initialOption]);

  const handleChange = useCallback(
    (_checked: boolean, newValue: string) => {
      setOption(newValue);
      if (onToggle) {
        onToggle(_checked, newValue);
      }
    },
    [onToggle],
  );

  const inputProps = get(bottomInputs, option, false);

  return (
    <>
      <FormLayout>
        <RadioStack
          initialState={initialOption}
          buttons={buttons}
          onToggle={handleChange}
          onInputChange={onInputChange}
        />
      </FormLayout>
      {inputProps && (
        <>
          <Separator fullWidth />
          {isValidElement(inputProps) && inputProps}
          {!isValidElement(inputProps) && (
            <InputContainer>
              <Input
                key={option}
                id={option}
                {...(inputProps as InputProps)}
                onChange={onInputChange}
              />
            </InputContainer>
          )}
        </>
      )}
    </>
  );
};

export default OptionStack;
